import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, InputLabel, useTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";

export default function LXDatePicker(props) {
  const {
    disabled = false,
    format = "MM/DD/yyyy",
    id = "date-picker-inline-timeCreatedUser",
    label = null,
    labelPlacement = "top",
    onChange,
    size,
    slotProps = {},
    useExternalLabel = true,
    value,
  } = props;
  const theme = useTheme();
  const { palette = {} } = theme;
  const { typography = {} } = palette;
  const classes = {
    inputField: {
      width: "100%",
    }
  };

  return (
    <Box
      sx={
        labelPlacement === "start"
          ? {
            display: "flex",
            alignItems: "center",
          }
          : {}
      }
    >
      {useExternalLabel
        ? <Box
          sx={{
            color: typography?.secondary,
            display: "flex",
            fontFamily: "Lato",
            fontWeight: "bold !important",
            justifyContent: "space-between",
            lineHeight: 1,
            marginBottom: `${labelPlacement === "start" ? "inherit" : ".5rem"}`,
            marginTop: `${labelPlacement === "start" ? "inherit" : ".2rem"}`,
            marginRight: `${labelPlacement === "start" ? ".5rem" : ""}`,
          }}
        >
          <InputLabel
            sx={{
              color: typography?.secondary,
              fontFamily: "Lato",
              fontWeight: "bold",
            }}
          >
            {label}
          </InputLabel>
        </Box>
        : null
      }

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          disabled={disabled}
          format={format}
          id={id}
          label={useExternalLabel ? null : label}
          onChange={(event) => {
            onChange(event);
          }}
          sx={classes.inputField}
          size={size}
          slotProps={slotProps}
          value={value}
        />
      </LocalizationProvider>
    </Box>
  );
}
